import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  min-height: 100vh;
  padding: 1rem;
  overflow-x: hidden;
  background-color: ${COLORS.WHITE};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;

  @media screen and ${DEVICES.LAPTOP_S} {
    background-color: ${COLORS.BRIGHT_GRAY};
    padding: 1.5rem 2rem 2rem;
  }
`;

export const StyledReportRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  min-width: 0;
  background: transparent;

  &[data-pdf-exporting='true'] {
    width: 1000px;
    max-width: 1000px;
    background: ${COLORS.WHITE};
    gap: 16px;
  }

  &[data-pdf-exporting='true'] .no-print {
    display: none !important;
  }
`;

export const StyledHeaderRow = styled.div.attrs({
  'data-pdf-block': 'true',
  'data-pdf-order': '1',
})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const StyledTitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  overflow: visible;

  [data-pdf-exporting='true'] & {
    gap: 0.5rem;
    padding-bottom: 0.25rem;
  }
`;

export const StyledPageTitle = styled.h1`
  margin: 0;
  ${pickThemeFontStyles('24', '32', 'BOLD')};
  color: ${COLORS.BLACK};
  overflow: visible;
`;

export const StyledPageSubtitle = styled.p`
  margin: 0;
  ${pickThemeFontStyles('14', '20', 'NORMAL')};
  color: ${COLORS.GRAY_PRIMARY};
`;

export const StyledPeriodLabel = styled.div`
  margin-top: 0.15rem;
  ${pickThemeFontStyles('14', '18', 'NORMAL')};
  color: ${COLORS.GRAY_PRIMARY};
  overflow: visible;

  [data-pdf-exporting='true'] & {
    margin-top: 0.25rem;
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
    line-height: 1.45;
  }
`;

export const StyledFiltersRow = styled.div``;

export const StyledBottomGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  min-width: 0;
  align-items: stretch;

  @media screen and ${DEVICES.LAPTOP_S} {
    grid-template-columns: minmax(0, 1fr) 30%;
  }

  [data-pdf-exporting='true'] & {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }
`;

export const StyledTablesStack = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  min-width: 0;
  order: 2;

  @media screen and ${DEVICES.LAPTOP_S} {
    order: 1;
  }

  [data-pdf-exporting='true'] & {
    display: flex;
    flex-direction: column;
    gap: 16px;
    order: 1;
    width: 100%;
  }
`;

export const StyledKpiCell = styled.div`
  min-width: 0;
  order: 1;

  @media screen and ${DEVICES.LAPTOP_S} {
    order: 2;
  }

  [data-pdf-exporting='true'] & {
    order: 2;
    width: 100%;
  }
`;

export const StyledReasonsCell = styled.div`
  min-width: 0;
`;

export const StyledPartnersCell = styled.div`
  min-width: 0;
`;

export const StyledNoPrint = styled.div.attrs({ className: 'no-print' })``;
